import { QueryClient } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

/**
 * Mémoire React Query de la visite (vit dans l'onglet, jamais sur disque).
 * Défauts conservés : une page revisitée affiche sa donnée tout de suite
 * puis relit en arrière-plan quand elle est périmée.
 */
export const queryClient = new QueryClient();

/** Vide toute la mémoire de la visite : aucun reste d'un compte précédent. */
export function clearVisitMemory(): void {
  queryClient.clear();
}

// Filet de sécurité : toute déconnexion (y compris session expirée) vide la mémoire.
supabase.auth.onAuthStateChange((event) => {
  if (event === "SIGNED_OUT") clearVisitMemory();
});
